(() => {
  if (window.gs18FeedbackLoaded) return;
  window.gs18FeedbackLoaded = true;
  // Prepare only the campaign discount; the shared landing snippet adds the product.
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-gs18-discount]');
    if (!form) return;
    if (form.dataset.discountPrepared === 'true') {
      delete form.dataset.discountPrepared;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('[type="submit"]');
    if (!button || button.disabled) return;
    const status = form.querySelector('[data-landing-cart-status]');
    const label = button.innerHTML;
    button.disabled = true;
    button.textContent = 'Adding…';
    button.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cart = window.theme?.cartReads ? await window.theme.cartReads.read() : await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}}).then(response => {
        if (!response.ok) throw new Error('Please try again.');
        return response.json();
      });
      const codes = (cart.discount_codes || []).map(item => item.code);
      codes.push(form.dataset.gs18Discount);
      const response = await (window.theme?.cartReads?.request || fetch)(root + 'cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({discount: [...new Set(codes)].join(',')})
      });
      if (!response.ok) throw new Error('We couldn’t apply this offer. Please try again.');
      form.dataset.discountPrepared = 'true';
      button.disabled = false;
      button.innerHTML = label;
      button.removeAttribute('aria-busy');
      form.requestSubmit(button);
    } catch (error) {
      if (status) status.textContent = error.message;
      button.disabled = false;
      button.innerHTML = label;
      button.removeAttribute('aria-busy');
    }
  }, true);
  function init() {
    document.querySelectorAll('[data-gs18-offers]').forEach(section => {
      if (section.dataset.choicesBound) return;
      section.dataset.choicesBound = 'true';
      section.addEventListener('change', event => {
        const choice = event.target.closest('[data-gs18-choice]');
        if (!choice) return;
        section.querySelectorAll('[data-gs18-visual], [data-gs18-detail]').forEach(panel => {
          panel.hidden = (panel.dataset.gs18Visual || panel.dataset.gs18Detail) !== choice.value;
        });
      });
    });
    const bar = document.querySelector('.gs18-sticky');
    const hero = document.querySelector('.gs18-hero');
    const footer = document.querySelector('.footer, footer, #shopify-section-footer');
    if (bar && hero && !bar.dataset.bound) {
      bar.dataset.bound = 'true';
      let heroAbove = false;
      let footerVisible = false;
      const update = () => { bar.hidden = !heroAbove || footerVisible || document.documentElement.classList.contains('js-drawer-open'); };
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === hero) heroAbove = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          if (entry.target === footer) footerVisible = entry.isIntersecting;
        });
        update();
      });
      observer.observe(hero);
      if (footer) observer.observe(footer);
      new MutationObserver(update).observe(document.documentElement, {attributes:true, attributeFilter:['class']});
    }
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
